import { optionsConstants } from '../redux-constants'

const initialState = {
    reservationView: 'calendar',
}

export default function options(state = initialState, action) {
    switch (action.type) {
        case optionsConstants.UPDATE:
            state = { ...state, ...action.payload }
            return state

        default:
            return state
    }
}
